import {useEffect, useState} from 'react'
import apiClient from 'src/services/apiClient'
// eslint-disable-next-line no-restricted-imports
import SelfRegistration from 'src/pages/selfRegistration/SelfRegistration'
import SelfRegistrationPageNew from './SelfRegistrationPageNew'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'

// Same shape as src/pages-new/passwordRecovery/PasswordRecoveryGate.tsx — fetches the
// pre-auth login-configuration payload and branches on `newStyleEnabled`, since redux
// isn't populated yet at this point in the app lifecycle.
const SelfRegistrationGate = () => {
  const [config, setConfig] = useState<any>()

  useEffect(() => {
    let mounted = true
    apiClient.loginConfiguration().then((res: any) => {
      if (mounted) setConfig(res)
    })
    return () => { mounted = false }
  }, [])

  if (!config) return null

  if (config.newStyleEnabled) {
    return (
      <ThemeProviderNew themeOverride={{primaryColor: config.primaryColor}}>
        <SelfRegistrationPageNew config={config} />
      </ThemeProviderNew>
    )
  }

  return <SelfRegistration />
}

export default SelfRegistrationGate
